<script setup>
/**
 * A broker's My Hubs: the hubs they work in, inside this hub's own chrome. An
 * owner's My Hubs is their XtendLive account instead, so only the account menu
 * of a broker in more than one hub leads here.
 */
import { onMounted } from 'vue';
import PageHeader from '../PageHeader.vue';
import XlCard from '../xl/XlCard.vue';
import XlListRow from '../xl/XlListRow.vue';
import XlTag from '../xl/XlTag.vue';
import { roleLabel } from '../../helpers/roles';
import { useMyHubs } from '../../composables/useMyHubs';

const { hubs, failed, load } = useMyHubs();

onMounted(load);
</script>

<template>
  <PageHeader />

  <div class="my-hubs" data-xl-gen="northstar">
    <header class="my-hubs__heading">
      <h1>My Hubs</h1>
      <p>The hubs you work in, and your role in each.</p>
    </header>

    <p v-if="failed" role="alert" class="my-hubs__state">Your hubs could not be loaded. Try again in a moment.</p>

    <XlCard v-else padded>
      <XlListRow v-for="hub in hubs" :key="hub.subdomain_name" data-testid="my-hub">
        <template #title>{{ hub.name }}</template>
        <template #subtitle><span data-testid="my-hub-role">{{ roleLabel(hub.role) }}</span></template>
        <template #trailing>
          <XlTag v-if="hub.current" tone="brand" data-testid="my-hub-current">You're here</XlTag>
          <a v-else :href="hub.url" target="_blank" rel="noopener" class="my-hubs__open">Open</a>
        </template>
      </XlListRow>
    </XlCard>
  </div>
</template>

<style scoped lang="scss">
.my-hubs {
  padding: var(--setup-page-padding) var(--setup-page-padding) 60px;
  font-family: var(--xl-font-family);
}

.my-hubs__heading {
  margin-bottom: 20px;

  h1 {
    margin: 0 0 6px;
    font-size: var(--xl-page-title-size);
    font-weight: 600;
    line-height: var(--xl-page-title-line);
    color: var(--xl-color-primary-text);
  }

  p {
    margin: 0;
    font-size: var(--xl-page-subtitle-size);
    line-height: var(--xl-page-subtitle-line);
    color: var(--xl-color-outline);
  }
}

.my-hubs__state {
  color: var(--xl-color-outline);
  font-size: 14px;
}

.my-hubs__open {
  font-size: 14px;
  font-weight: 600;
  color: var(--xl-color-primary);
  text-decoration: none;

  &:hover { text-decoration: underline; }
}
</style>
